import { render, staticRenderFns } from "./CollectionCardSummary.vue?vue&type=template&id=68ccaa79&"
import script from "./CollectionCardSummary.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports